@if (response) {
    <div class="w-full">
        <mat-drawer-container class="flex-auto h-full p-4 md:p-8">
            <mat-drawer-content class="flex flex-col overflow-hidden">
                <div class="prose prose-sm max-w-100 flex gap-2 justify-between">
                    <h2>
                        {{ 'label_mortgage_eligibility_form' | translate }}
                        @if (response) {
                            <span>-</span>
                            <a
                                class="c-link text-lg"
                                target="_blank"
                                [href]="response.externalServiceLink"
                                matTooltip="Opna umsókn í Coredata"
                            >
                                {{ response.externalServiceId }}
                            </a>
                        }
                    </h2>
                    <div>
                        <button mat-icon-button (click)="onCopyDataFromOtherMortgageEligibilityInfo()">
                            <mat-icon fontIcon="content_copy"></mat-icon>
                        </button>
                        @if (infoPanelMode == 'over') {
                            <button mat-icon-button (click)="toggleInfoPanel()">
                                <mat-icon fontIcon="chevron_left"></mat-icon>
                            </button>
                        }
                    </div>
                </div>
                @if (response && response.originatingSystem) {
                    <span class="block italic">
                        {{ 'label_' + response.originatingSystem | translate }}
                        - {{ 'label_application' | translate }}:
                        {{ response.originatingSystemApplicationId }}
                    </span>
                }
                <mat-divider class="my-4"></mat-divider>
                <form class="w-full grid gap-4" [formGroup]="form">
                    <div class="grid grid-cols-1 gap-4 justify-between sm:justify-start">
                        <mat-label class="font-medium">
                            {{ 'label_property' | translatePlural }}
                        </mat-label>
                        <div class="grid h-fit overflow-x-auto">
                            <form-array-table
                                [displayedColumns]="propertiesDisplayedColumns"
                                [data]="properties"
                                [options]="propertiesTableOptions"
                                (onRemoveRowEvent)="onRemoveProperty($event)"
                                (onRefreshRowEvent)="onRefetchPropertyInfo($event)"
                                (onValueChangesEvent)="calculateInfo()"
                            >
                                <ng-container matColumnDef="propertyNumber">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{ 'label_property_number' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" [formGroup]="element">
                                        {{ element.get('propertyNumber').value }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="address">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{ 'label_address' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" [formGroup]="element">
                                        {{ getPropertyAddressString(element) }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="propertyEvaluation">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{ 'property_evaluation' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" [formGroup]="element">
                                        <mat-form-field>
                                            <input matInput maxlength="11" numericFormat formControlName="propertyEvaluation" />
                                            <span matSuffix>kr.</span>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="landEvaluation">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{ 'label_land_evaluation' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" [formGroup]="element">
                                        <mat-form-field>
                                            <input matInput maxlength="11" numericFormat formControlName="landEvaluation" />
                                            <span matSuffix>kr.</span>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="fireCompensationEvaluation">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{ 'label_fire_compensation_evaluation' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" [formGroup]="element">
                                        <mat-form-field>
                                            <input matInput maxlength="11" numericFormat formControlName="fireCompensationEvaluation" />
                                            <span matSuffix>kr.</span>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                            </form-array-table>
                        </div>
                        <button class="w-fit justify-self-end" mat-flat-button type="button" [color]="'primary'" (click)="onAddProperty()">
                            <mat-icon class="icon-size-5" fontIcon="add" matPrefix></mat-icon>
                            {{ 'label_add_property' | translate }}
                        </button>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    <div class="grid grid-cols-12 gap-4">
                        <div id="estimate_inputs" class="col-span-12 grid grid-cols-2 lg:flex gap-4">
                            <div class="grid fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1 lg:max-w-sm">
                                <mat-label>
                                    {{ 'property_evaluation' | translate }} ({{ 'label_total' | translate | lowercase }})
                                </mat-label>
                                <div class="font-semibold">
                                    {{ info.evaluationTotals.propertyEvaluation | translocoDecimal }}
                                    <span matSuffix>kr.</span>
                                </div>
                            </div>
                            <div class="grid fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1 lg:max-w-sm">
                                <mat-label>
                                    {{ 'label_land_evaluation' | translate }}
                                    ({{ 'label_total' | translate | lowercase }})
                                </mat-label>
                                <div class="font-semibold">
                                    {{ info.evaluationTotals.landEvaluation | translocoDecimal }}
                                    <span matSuffix>kr.</span>
                                </div>
                            </div>
                            <div class="grid fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1 lg:max-w-sm">
                                <mat-label>
                                    {{ 'label_fire_compensation_evaluation' | translate }}
                                    ({{ 'label_total' | translate | lowercase }})
                                </mat-label>
                                <div class="font-semibold">
                                    {{ info.evaluationTotals.fireCompensationEvaluation | translocoDecimal }}
                                    <span matSuffix>kr.</span>
                                </div>
                            </div>
                            <mat-form-field class="fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1 lg:max-w-sm">
                                <mat-label>{{ 'label_purchase_price' | translate }}</mat-label>
                                <input formControlName="purchasePrice" numericFormat maxlength="11" matInput />
                                <span matSuffix>kr.</span>
                            </mat-form-field>
                        </div>
                        <mat-divider class="col-span-12"></mat-divider>
                        <div class="grid grid-cols-12 col-span-12 gap-4">
                            <div class="flex flex-col gap-4 col-span-12 xxl:col-span-8">
                                <mat-label class="font-medium">{{ 'label_current_loans' | translate }}</mat-label>
                                <div id="current_mortgages" class="grid h-fit overflow-x-auto">
                                    <form-array-table
                                        [displayedColumns]="currentMortgagesDisplayedColumns"
                                        [data]="currentMortgagesArray"
                                        [options]="mortgageTableOptions"
                                        (onRemoveRowEvent)="onRemoveCurrentMortgageRow($event)"
                                        (onMoveRowEvent)="onMoveCurrentMortgageRow($event)"
                                        (onValueChangesEvent)="calculateInfo()"
                                    >
                                        <ng-container matColumnDef="mortgageLender">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_loan_lender' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                <mat-form-field>
                                                    <mat-select formControlName="mortgageLender" [placeholder]="'label_select' | translate">
                                                        @for (option of config.mortgageLenderOptions; track option) {
                                                            <mat-option [value]="option.value">
                                                                {{ option.label | translate }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>
                                        <ng-container matColumnDef="mortgageBalance">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_status' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                <mat-form-field>
                                                    <input matInput maxlength="11" numericFormat formControlName="mortgageBalance" />
                                                    <span matSuffix>kr.</span>
                                                </mat-form-field>
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef>
                                                {{ info.currentMortgagesTotalCurrentAmount | translocoDecimal }}
                                                kr.
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mortgageDeposit">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_deposit' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                <mat-form-field>
                                                    <input
                                                        matInput
                                                        numericFormat
                                                        [max]="element.get('mortgageBalance').value"
                                                        maxlength="11"
                                                        formControlName="mortgageDeposit"
                                                    />
                                                    <span matSuffix>kr.</span>
                                                </mat-form-field>
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef>
                                                {{ info.currentMortgagesTotalDeposit | translocoDecimal }}
                                                kr.
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mortgageNewBalance">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_new_status' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                {{ getNewMortgageBalance(element) | translocoDecimal }}
                                                kr.
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef>
                                                {{ info.currentMortgagesTotalNewAmount | translocoDecimal }}
                                                kr.
                                            </td>
                                        </ng-container>
                                    </form-array-table>
                                </div>
                                <button
                                    class="w-32 self-end"
                                    mat-flat-button
                                    type="button"
                                    [color]="'primary'"
                                    (click)="onAddCurrentMortgageRow()"
                                >
                                    <mat-icon class="icon-size-5" fontIcon="add" matPrefix></mat-icon>
                                    {{ 'label_add_loan' | translate }}
                                </button>
                            </div>
                            <div class="flex flex-col gap-4 col-span-12 xxl:col-span-4">
                                <mat-label class="font-medium">
                                    {{ 'label_new_and_transferred_loans' | translate }}
                                </mat-label>
                                <div id="new_loans" class="grid h-fit overflow-x-auto">
                                    <form-array-table
                                        [displayedColumns]="newMortgagesDisplayedColumns"
                                        [data]="newMortgagesArray"
                                        [options]="mortgageTableOptions"
                                        (onRemoveRowEvent)="onRemoveNewMortgageRow($event)"
                                        (onMoveRowEvent)="onMoveNewMortgageRow($event)"
                                        (onValueChangesEvent)="calculateInfo()"
                                    >
                                        <ng-container matColumnDef="mortgageType">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_type' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                <mat-form-field>
                                                    <mat-select formControlName="mortgageType" [placeholder]="'label_select' | translate">
                                                        @for (option of config.mortgageTypeOptions; track option) {
                                                            <mat-option [value]="option.value">
                                                                {{ option.label | translate }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>
                                        <ng-container matColumnDef="mortgageBalance">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{ 'label_amount' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                <mat-form-field>
                                                    <input matInput numericFormat maxlength="11" formControlName="mortgageBalance" />
                                                </mat-form-field>
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef>
                                                {{ info.newMortgagesTotalAmount | translocoDecimal }}
                                                kr.
                                            </td>
                                        </ng-container>
                                    </form-array-table>
                                </div>
                                <button
                                    class="w-32 self-end"
                                    mat-flat-button
                                    type="button"
                                    [color]="'primary'"
                                    (click)="onAddNewMortgageRow()"
                                >
                                    <mat-icon class="icon-size-5" fontIcon="add" matPrefix></mat-icon>
                                    {{ 'label_add_loan' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    @if (infoPanelMode == 'over') {
                        <div class="text-right">
                            <button class="w-32" mat-flat-button type="button" [color]="'primary'" (click)="onSave()">
                                <mat-icon class="icon-size-5 mr-1" fontIcon="save" matPrefix></mat-icon>
                                {{ 'label_save_document' | translate }}
                            </button>
                        </div>
                    }
                </form>
                <div class="min-h-[1100px] overflow-hidden">
                    @if (response && response.properties && response.properties.length > 0) {
                        <mat-tab-group class="hjalp-tab-group fade-in-left" [animationDuration]="'0'">
                            <mat-tab [label]="'label_property_registry_overview' | translate">
                                <mortgage-eligibility-form-property-historical-documents
                                    [data]="response"
                                    [historicalDocumentsProperty]="'historicalPropertyInfoDocuments'"
                                    [documentProperty]="'propertyInfoDocument'"
                                    [noDataLabel]="'info_property_info_document_no_data'"
                                    [fileName]="'label_property_registry_overview' | translate"
                                >
                                </mortgage-eligibility-form-property-historical-documents>
                            </mat-tab>
                            @if (response && response.properties && response.properties.length > 0) {
                                <mat-tab [label]="'label_property_registry_encumbrance_overview' | translate">
                                    <mortgage-eligibility-form-property-historical-documents
                                        [data]="response"
                                        [historicalDocumentsProperty]="'historicalPropertyEncumbranceInfoDocuments'"
                                        [documentProperty]="'propertyEncumbranceInfoDocument'"
                                        [noDataLabel]="'info_property_encumbrance_info_document_no_data'"
                                        [fileName]="'label_property_registry_encumbrance_overview' | translate"
                                    >
                                    </mortgage-eligibility-form-property-historical-documents>
                                </mat-tab>
                            }
                        </mat-tab-group>
                    }
                </div>
            </mat-drawer-content>
            <mat-divider class="my-4 h-full" [vertical]="true"></mat-divider>
            <mat-drawer
                class="dark:bg-gray-900 w-96 side-info"
                [mode]="infoPanelMode"
                position="end"
                [opened]="infoPanelOpen"
                [disableClose]="infoPanelMode == 'side'"
            >
                @if (infoPanelMode == 'over') {
                    <button class="absolute inset-3" mat-icon-button (click)="toggleInfoPanel()">
                        <mat-icon fontIcon="chevron_right"></mat-icon>
                    </button>
                }
                <div class="grid gap-2 mb-4 w-full mt-8 xl:mt-0">
                    <span class="font-medium flex items-center">
                        {{ 'label_mortgage_ratio' | translate }}
                        @if (info.mortgageRatios.total > 0 && !errors.mortgageRatios.hasError) {
                            <mat-icon class="icon-size-6 ml-2 text-green-600" fontIcon="check_circle"></mat-icon>
                        }
                        @if (errors.mortgageRatios.hasError) {
                            <mat-icon class="icon-size-6 ml-2 text-red-800" fontIcon="cancel"></mat-icon>
                        }
                    </span>
                    <span>{{ 'label_lsr' | translate }}: {{ info.mortgageRatios.lsr | percent: '1.0-1' }}</span>
                    <span>
                        {{ 'label_other_person' | translatePlural }}:
                        {{ info.mortgageRatios.other | percent: '1.0-1' }}
                    </span>
                    <span>{{ 'label_total' | translate }}: {{ info.mortgageRatios.total | percent: '1.0-1' }}</span>
                    <span
                        [ngClass]="{
                            invisible: !errors.mortgageRatios.hasError,
                        }"
                        class="text-red-800"
                    >
                        {{ errors.mortgageRatios.message || '-' }}
                    </span>
                </div>
                <div class="grid gap-2 w-full">
                    <span class="font-medium flex items-center">
                        {{ 'label_loans_after_mortgage' | translate }}
                        @if (info.mortgageAmounts.total > 0 && !errors.mortgageAmounts.hasError) {
                            <mat-icon class="icon-size-6 ml-2 text-green-600" fontIcon="check_circle"></mat-icon>
                        }
                        @if (errors.mortgageAmounts.hasError) {
                            <mat-icon class="icon-size-6 ml-2 text-red-800" fontIcon="cancel"></mat-icon>
                        }
                    </span>
                    <span
                        >{{ 'label_lsr' | translate }}:
                        {{ info.mortgageAmounts.lsr | translocoDecimal }}
                        kr.</span
                    >
                    <span>
                        {{ 'label_other_person' | translatePlural }}:
                        {{ info.mortgageAmounts.other | translocoDecimal }}
                        kr.
                    </span>
                    <span
                        >{{ 'label_total' | translate }}:
                        {{ info.mortgageAmounts.total | translocoDecimal }}
                        kr.</span
                    >
                    <span
                        [ngClass]="{
                            invisible: !errors.mortgageAmounts.hasError,
                        }"
                        class="text-red-800"
                    >
                        {{ errors.mortgageAmounts.message || '-' }}
                    </span>
                </div>
                <mat-divider class="mt-4 mb-8 w-full"></mat-divider>
                <div class="grid gap-2 mb-8 w-full">
                    <span class="font-medium">{{ 'label_max_loan' | translate }}</span>
                    <span
                        [ngClass]="{
                            'font-bold': info.mortgageLimits.onlyLSRLoans.active,
                        }"
                    >
                        {{ info.mortgageLimits.onlyLSRLoans.limitBasis | translate }}
                        {{ config.mortgageRatioLimits.onlyLSRLoans | percent }}:
                        {{ info.mortgageLimits.onlyLSRLoans.amount | translocoDecimal }}
                        kr.
                    </span>
                    <span
                        [ngClass]="{
                            'font-bold': info.mortgageLimits.withOtherLoans.active,
                        }"
                    >
                        {{ info.mortgageLimits.withOtherLoans.limitBasis | translate }}
                        {{ config.mortgageRatioLimits.withOtherLoans | percent }}:
                        {{ info.mortgageLimits.withOtherLoans.amount | translocoDecimal }}
                        kr.
                    </span>
                    <span
                        [ngClass]="{
                            'font-bold': info.mortgageLimits.fireCompensationAndLandEvaluation.active,
                        }"
                    >
                        {{ 'label_fire_compensation_evaluation' | translate }} +
                        {{ 'label_plot_of_land' | translate }}
                        {{ config.mortgageRatioLimits.fireCompensationAndLandEvaluation | percent }}:
                        {{ info.mortgageLimits.fireCompensationAndLandEvaluation.amount | translocoDecimal }}
                        kr.
                    </span>
                    <span
                        [ngClass]="{
                            'font-bold': info.mortgageLimits.maxLimit.active,
                        }"
                    >
                        {{ 'label_max_lsr_loans' | translate }}:
                        {{ info.mortgageLimits.maxLimit.amount | translocoDecimal }}
                        kr.
                    </span>
                </div>
                <mat-divider class="mt-4 mb-8 w-full"></mat-divider>
                <div class="grid gap-2 mb-8 w-full">
                    <span class="font-medium">{{ 'label_loan_preapproval_amount' | translate }}</span>
                    <span>
                        {{ 'label_total_amount' | translate }}:
                        {{ info.maxAvailableMortgageAmount | translocoDecimal }}
                        kr.
                    </span>
                    <span
                        [ngClass]="{
                            'text-red-800': info.unusedAvailableMortgageAmount < 0,
                        }"
                    >
                        {{ 'label_unused_amount' | translate }}:
                        {{ info.unusedAvailableMortgageAmount | translocoDecimal }}
                        kr.
                    </span>
                </div>
                @if (infoPanelMode == 'side') {
                    <mat-divider class="my-4 w-full"></mat-divider>
                }
                <div class="text-center">
                    @if (infoPanelMode == 'side') {
                        <button class="w-32" mat-flat-button type="button" [color]="'primary'" (click)="onSave()">
                            <mat-icon class="icon-size-5 mr-1" fontIcon="save" matPrefix></mat-icon>
                            {{ 'label_save_document' | translate }}
                        </button>
                    }
                </div>
            </mat-drawer>
        </mat-drawer-container>
    </div>
}
